/** 12 categorías: toda pista se responde tocando un punto del mapa ("¿dónde…?"). */
export const CATEGORIES = [
  "estadio",
  "cuna",
  "final",
  "club",
  "torneo",
  "derbi",
  "latino",
  "trayectoria",
  "record",
  "femenino",
  "momento",
  "aficion",
  "actualidad",
] as const;
export type Category = (typeof CATEGORIES)[number];

export const CATEGORY_LABELS: Record<Category, string> = {
  estadio: "Estadios",
  cuna: "Cuna de cracks",
  final: "Finales históricas",
  club: "Clubes y apodos",
  torneo: "Mundiales y torneos",
  derbi: "Derbis y rivalidades",
  latino: "Fútbol latino",
  trayectoria: "Fichajes y trayectorias",
  record: "Récords y curiosidades",
  femenino: "Fútbol femenino",
  momento: "Goles y momentos míticos",
  aficion: "Aficiones y tradiciones",
  actualidad: "Actualidad",
};

/** Zonas para la mezcla geográfica de la receta (derivadas del país de la respuesta). */
export const ZONES = ["espana", "europa", "america", "resto"] as const;
export type Zone = (typeof ZONES)[number];

export const ZONE_LABELS: Record<Zone, string> = {
  espana: "España",
  europa: "Europa",
  america: "América",
  resto: "Resto del mundo",
};

export const QUESTION_STATUSES = ["borrador", "verificada", "retirada"] as const;
export type QuestionStatus = (typeof QUESTION_STATUSES)[number];

export const PLAY_STATUSES = ["en_curso", "completada", "cerrada"] as const;
export type PlayStatus = (typeof PLAY_STATUSES)[number];

export type Band = "green" | "yellow" | "red";

export const PLAY_POSITIONS = [1, 2, 3, 4, 5] as const;
export type Position = (typeof PLAY_POSITIONS)[number];

/** Pista tal como viaja al cliente: nunca incluye la respuesta. */
export interface PublicClue {
  position: Position;
  clue: string;
  category: Category;
}

/** Ronda tal como la recibe el cliente para jugar. */
export interface PublicRound {
  id: string;
  number: number;
  gameDate: string;
  questions: PublicClue[];
  nextRolloverAt: string;
}

/** Respuesta de una pista, revelada solo tras registrar el intento. */
export interface RevealedAnswer {
  name: string;
  city: string | null;
  lat: number;
  lng: number;
  explanation: string;
}

export interface GuessResult {
  position: Position;
  distanceKm: number;
  score: number;
  band: Band;
  answer: RevealedAnswer;
}

export interface PlayProgress {
  position: Position;
  score: number;
  band: Band;
  distanceKm: number;
  guessLat: number;
  guessLng: number;
  answer: RevealedAnswer;
}

export type PlayState = "no_iniciada" | "en_curso" | "completada";

export interface PlayCurrent {
  state: PlayState;
  round: PublicRound;
  /** Posición de la siguiente pista pendiente (1..5) cuando la partida está en curso. */
  nextPosition: Position | null;
  guesses: PlayProgress[];
  totalScore: number | null;
  percentile: number | null;
  currentStreak: number | null;
  shareId: string | null;
  referrerShareId: string | null;
}

export interface PlayerStats {
  played: number;
  average: number;
  best: number;
  currentStreak: number;
  bestStreak: number;
  distribution: { from: number; to: number; count: number }[];
}
